import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOnProcessVendorSourceLocationDTO from "../../../models/DTO/IOnProcessVendorSourceLocationDTO";
import IProcessVendorSourceLocationDTO from "../../../models/DTO/IProcessVendorSourceLocationDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IAddress from "../../../models/IAddress";
import INewAddress from "../../../models/INewAddress";
import INotification from "../../../models/INotification";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendor_Source from "../../../models/IVendor_Source";
import IVendor_Source_Location from "../../../models/IVendor_Source_Location";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import AddressBlock from "../../shared/AddressBlock/AddressBlock";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    vendorSource: IVendor_Source;
    vendorSourceLocation?: IVendor_Source_Location;
};

type State = {
    createActive: boolean;
    address: IAddress | INewAddress;
};

class VendorSourceLocationSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        let address = {} as INewAddress;

        if (this.props.vendorSourceLocation) {
            address = this.props.vendorSourceLocation.Address!;
            address.name = this.props.vendorSourceLocation.name;
        }

        this.state = {
            createActive: false,
            address,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnProcessVendorSourceLocation, this.onProcessVendorSourceLocation);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.PurchaseOrderOnProcessVendorSourceLocation, this.onProcessVendorSourceLocation);
    }

    processVendorSourceLocation = () => {
        // @ts-expect-error
        const payload: IProcessVendorSourceLocationDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorSourceGuid: this.props.vendorSource.guid,
        };

        if (!this.props.vendorSourceLocation) {
            payload.newAddress = this.state.address;
            // @ts-expect-error
            payload.location = {
                name: this.state.address.name || "",
            };
        } else {
            // @ts-expect-error
            payload.location = {
                ...this.props.vendorSourceLocation,
                Address: this.state.address as IAddress,
                name: this.state.address.name!,
            };
        }

        this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessVendorSourceLocation, payload);

        this.setState({
            createActive: true,
        });
    };

    onProcessVendorSourceLocation = (data: IOnProcessVendorSourceLocationDTO) => {
        const notification: INotification = {
            message: "successfully_processed_vendor_source_location",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.props.cancelFn(true);

        this.setState({
            createActive: false,
        });
    };

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    create = () => {
        this.processVendorSourceLocation();
    };

    handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.value;

        const address = this.state.address;

        // @ts-expect-error
        address[name] = value;

        this.setState({
            address,
        });
    };

    render() {
        return (
            <div className={"VendorSourceLocationSidebar p-2"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} title={"vendor_source_location"} />
                    <hr />
                </div>

                <div className={"col-12"}>{this.props.vendorSource.name}</div>

                <div className={"col-12"}>
                    <AddressBlock fn={this.handleChange} showName={true} address={this.state.address} />
                </div>

                <div>
                    <OwButton title={"save"} fn={this.create} active={this.state.createActive} disableOnActive={true} />
                </div>
            </div>
        );
    }
}

export default VendorSourceLocationSidebar;
